module.exports = __webpack_public_path__ + "img/locations_layout2.cf48ff10.png";